
import { useEffect, useRef } from 'react';
import { ReportsSection } from '@/components/reports/ReportsSection';
import { AppLayoutWithHeader } from '@/components/layout/AppLayoutWithHeader';
import { ContentContainer } from '@/components/layout/ContentContainer';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';


const Reports = () => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { toast } = useToast();
  
  // Récupérer le filtre depuis l'URL
  const urlFilter = searchParams.get('filter');
  const lastToastFilter = useRef<string | null>(null);
  
  // Afficher un toast quand on arrive sur une vue filtrée (une seule fois)
  useEffect(() => {
    if (urlFilter === 'not-shared' && urlFilter !== lastToastFilter.current) {
      toast({
        title: "Rapports non partagés",
        description: "Vue filtrée active",
      });
      lastToastFilter.current = urlFilter;
    } else if (!urlFilter) {
      lastToastFilter.current = null;
    }
  }, [urlFilter, toast]);

  return (
    <AppLayoutWithHeader 
      title="Rapport 📊"
      layoutMode="default"
      sidebarVisible={true}
    >
      <ContentContainer className="w-full">
        <ReportsSection 
          initialSelectedReportId={location.state?.selectedReportId}
          fromDashboard={location.state?.fromDashboard}
          fromNotification={location.state?.fromNotification}
          urlFilter={urlFilter}
          onResetFilter={() => setSearchParams({})}
        />
      </ContentContainer>
    </AppLayoutWithHeader>
  );
};

export default Reports;
